import { Button } from "primereact/button"
import { FC, useContext, useEffect, useState } from "react"
import { BsPersonFillAdd } from "react-icons/bs"
import { ADMIN_PERMISSIONS } from "../../data/constants"
import { IAdminTable } from "../../models/AdminModel"
import { UserContext } from "../../Redux/UserContext"
import { getAdminTable, getRoles } from "../../services/admin-service"
import { catchResponse } from "../../utils/helperFunctions"
import { error } from "../../utils/notifications"
import './admin.css'
import { AdminAsignUserModal } from "./AdminAsignUserModal/AdminAsignUserModal"
import { AdminTable } from "./AdminTable/AdminTable"

export const Admin:FC<any> = (props):JSX.Element => {

    const { flagGlobal, setFlagGlobal } = props

    const [open, setOpen] = useState<boolean>(false)

    const [nuevo, setNuevo] = useState<boolean>(true)

    const [state] = useContext(UserContext)

    const [flagAdmin, setFlagAdmin] = useState<boolean>(true)

    const [valuesPlanta, setValuesPlanta] = useState<any[]>([])

    const INITIAL_ADMIN_STATE:IAdminTable = {
        id_user: "",
        email: "",
        name_rol: "",
        name_user: "",
        id_rol: -1,
        id_plants : []
    }

    const [selectedUser, setSelectedUser] = useState<IAdminTable>(INITIAL_ADMIN_STATE)

    const [loadingEditUser, setLoadingEditUser] = useState<boolean>(false)

    const [dataTable, setDataTable] = useState<any[]>([])

    const [roles, setRoles] = useState<any[]>([])

    const handleOpenModal = () => {
        setNuevo(true)
        setOpen(true)
    }

    const handleCloseModal = () => {
        setOpen(false)
        setValuesPlanta([])
        setSelectedUser(INITIAL_ADMIN_STATE)
    }

    const handleOpenEditModal = () => {
        setNuevo(false)
        setOpen(true)
    }

    const ordenarConExcepcion = (arr:[]) => {
        const sortedRoles:any = arr.filter((role:any) => role.id_rol !== 6).sort((a:any, b:any) => a.id_rol - b.id_rol);
        const roleWithId6:any = arr.find((role:any) => role.id_rol === 6)
        
        sortedRoles.splice(1, 0, roleWithId6);
        
        return sortedRoles;
      }

    const fetchRoles = async() => {
        try {
            const res = await getRoles()
            
            if(res.status === 200) {
                const { code, data, message } = res.data
                if(code === 200) {
                    setRoles(ordenarConExcepcion(data))
                } else {
                    error(message)
                }
            } else {
                error("Error obteniendo los roles de usuario")
            }
        } catch(err:any) {
            catchResponse(err)
        }
    }

    const fetchAdminTable = async() => {
        try {
            const res = await getAdminTable()
            
            if(res.status === 200) {
                const { code, data, message } = res.data
                if(code === 200) {
                    setDataTable(data[0])
                } else {
                    error(message)
                }
            } else {
                error("Error obteniendo la tabla de permisos")
            }
        } catch(err:any) {
            catchResponse(err)
        }
    }

    useEffect(() => {
        fetchAdminTable()
        fetchRoles()
    }, [flagAdmin])

    return (
        <div className="admin__wrapper">
            <AdminAsignUserModal
                visible={open}
                setVisible={setOpen} 
                handleCloseModal={handleCloseModal}
                handleOpenModal={handleOpenModal}
                nuevo={nuevo}
                selectedUser={selectedUser}
                setSelectedUser={setSelectedUser}
                flagAdmin={flagAdmin}
                setFlagAdmin={setFlagAdmin}
                flagGlobal={flagGlobal}
                setFlagGlobal={setFlagGlobal}
                loadingEditUser={loadingEditUser}
                setLoadingEditUser={setLoadingEditUser}
                valuesPlanta={valuesPlanta}
                setValuesPlanta={setValuesPlanta}
                roles={roles}

                />
            <Button style={{minWidth:250}} label={"Añadir permiso"} disabled={state?.rol_id !== undefined? !ADMIN_PERMISSIONS.C.includes(state?.rol_id) : false} icon={ <BsPersonFillAdd style={{fontSize:18,marginRight:'1rem'}} />}  onClick={handleOpenModal}  outlined />
            <AdminTable
                dataTable={dataTable}
                handleOpenEditModal={handleOpenEditModal}
                handleCloseModal={handleCloseModal}
                selectedUser={selectedUser}
                setSelectedUser={setSelectedUser}
                flagAdmin={flagAdmin}
                setFlagAdmin={setFlagAdmin}
                flagGlobal={flagGlobal}
                setFlagGlobal={setFlagGlobal}
                valuesPlanta={valuesPlanta}
                setValuesPlanta={setValuesPlanta}
                
                />
        </div>
    )
}